<div class="contenedor-form" *ngIf="loadingUsuario">
  <mat-spinner
    [diameter]="100"
    style="margin:0 auto; top:15px;"
  ></mat-spinner>
</div>

<div style="text-align: center; margin-bottom: 20px;" *ngIf="!loadingUsuario">
  <form [formGroup]="usuarioGrupo" (ngSubmit)="submitForm()">
    <div class="row">
      <div class="col s12 m4 l4">
          <select style="margin-top: 15px;" formControlName="IdTpoUsuario">
              <option value="" disabled selected>TIPO USUARIO</option>
              <option *ngFor="let opt of tiposUsuario" [value]="opt.id">
                {{ opt.valor }}
              </option>
            </select>
      </div>
      <div class="col s12 m4 l4">
        <mat-form-field class="example-full-width">
          <input
            matInput
            placeholder="USUARIO"
            formControlName="Usuario"
            type="text"
          />
        </mat-form-field>
      </div>
      <div class="col s12 m4 l4">
          <mat-form-field class="example-full-width">
              <input
                matInput
                placeholder="CLAVE"
                formControlName="Clave"
                type="password"
              />
            </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col s6 m6 l6">
          <mat-form-field class="example-full-width">
              <input
                matInput
                placeholder="DESCRIPCION"
                formControlName="Descripcion"
                type="text"
              />
            </mat-form-field>
      </div>
      <div class="col s6 m6 l6">
        <mat-form-field>
          <mat-select placeholder="AGENCIAS" formControlName="formAgencias" multiple>                
            <mat-option *ngFor="let item of agencias" [value]="item.id">{{item.valor}}</mat-option>
          </mat-select>
        </mat-form-field> 
      </div>
    </div>
    
    <button
      mat-raised-button
      type="submit"
      color="accent"
      [disabled]="!usuarioGrupo.valid"
    >
      Actualizar
    </button>
  </form>
</div>

